export default __webpack_public_path__ + "static/drag-and-drop-0ad7aa482a60d60f7675324e4a14dd32.mp4";